//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getConfiguration } from "@nuskin/configuration-sdk";
import { NsIcon } from "@nuskin/design-components";
import { EquinoxCartService } from "@nuskin/ns-shop";
import {
  ConfigService,
  events,
  RunConfigService,
  equinoxLocalStorage
} from "@nuskin/ns-util";

export default {
  name: "NsMinimalHeaderMiniCartVue",
  components: {
    NsIcon
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      localCount: 0
    };
  },
  computed: {
    cartCount() {
      return this.localCount || this.count || 0;
    },
    cartUrl() {
      // Cartservice doesn't work for this yet
      const { language, country } = RunConfigService.getRunConfig();
      return `/${country}/${language}/viewCart`;
    },
    countDisplay() {
      if (this.cartCount < 1) {
        return "";
      } else if (this.cartCount < 100) {
        return this.cartCount;
      } else {
        return 99;
      }
    },
    iconName() {
      if (this.cartCount < 1) {
        return "icon-largecart-empty";
      } else if (this.cartCount < 100) {
        return "icon-largecart-099";
      } else {
        return "icon-largecart-99p";
      }
    }
  },
  mounted: function() {
    const country = RunConfigService.getRunConfig().country;

    if (equinoxLocalStorage.isEquinoxEnabled()) {
      getConfiguration(["Equinox_Markets"], {
        country: country,
        environment: RunConfigService.getEnvironmentCode(),
        clientId: ConfigService.getMarketConfig().checkout.clientId
      }).then(config => {
        if (
          country === config.Equinox_Markets.country_code &&
          config.Equinox_Markets.active
        ) {
          const component = this;
          EquinoxCartService.getEquinoxCart().then(response => {
            component.localCount =
              response &&
              response.data &&
              response.data.value &&
              response.data.value.count;
          });
        }
      });
    }

    this.setupListener();
  },
  methods: {
    setupListener() {
      let that = this;
      events.subscribe(events.shop.CART_UPDATED, info => {
        if (info && info.cartInfo.qty !== undefined) {
          that.localCount = info.cartInfo.qty > 0 ? info.cartInfo.qty : 0;
        }
      });
    }
  }
};
